import script from "./Attendance.vue?vue&type=script&setup=true&lang=js"
export * from "./Attendance.vue?vue&type=script&setup=true&lang=js"

import "./Attendance.vue?vue&type=style&index=0&id=171e8377&lang=css"

const __exports__ = script;

export default __exports__